import { useRef } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';

export default function MaxReserveQueue(props) {
  const { value, setValue, onBlur } = props;
  const { t } = useLanguage();

  const snapshotRef = useRef(value);

  // 입력값 변경시 //
  function onChangeInput(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");
    setValue(result === '' ? 0 : parseInt(result));
  }

  // 입력 포커스시 — blur 시 변경 판정용 스냅샷 //
  function onFocusInput() {
    snapshotRef.current = value;
  }

  // 입력 포커스 해제시 //
  function onBlurInput() {
    if (value === snapshotRef.current) return;
    const prev = snapshotRef.current;
    snapshotRef.current = value;
    if (onBlur) onBlur(value, () => {
      setValue(prev);
      snapshotRef.current = prev;
    });
  }

  return (
    <TopLevelWrapper>
      <TopWrapper>
        <LeftWrapper>
          <Input
            placeholder={0}
            value={value}
            onChange={onChangeInput}
            onFocus={onFocusInput}
            onBlur={onBlurInput} />
        </LeftWrapper>
        <Text
          fontFamily='NotoSansKR-Regular'
          fontSize={12}>
          {t('system.people')}
        </Text>
      </TopWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 8px;

  transition: all 0.3s ease-in-out;
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 53px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  padding: 0 8px 0 8px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  ::placeholder {
    color: ${props => props.theme.line};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;
